import {React, useState, useEffect, useRef} from "react";
import './style.scss';
import { image } from "../../Assets";
import Count from "../../Component/Count/Count";
import CaseStudy from "../../Component/caseStudy/casestudy";
import BookCall from "../../Component/BookCall/BookCall";

const ServicesLayout =(props)=>{

  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef(null);
    
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") setOpenModal(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [ openModal]);
  
    return(
        <>
            <section className="banner-Visualisation" style={{backgroundImage:`linear-gradient(135deg, #15743880 0%, #15743880 100%), url(${props.banner})`,backgroundRepeat:'no-repeat',backgroundSize:'cover'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <p className="breadcrumb">
                             What we do / {props.mainservice}
                            </p>
                            <h2>    
                                {props.serviceName}
                            </h2>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tw-py-10 md:tw-py-20" style={{background:'#fff'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p data-aos="fade-right" className="tw-text-[20px] md:tw-text-[32px]" style={{textAlign:'center', color:'#157438'}}>
                            {props.maincontent}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="company-bg" style={{background:`url(${props.banner2})`,backgroundSize:'cover'}}></section>   
            
            <section style={{background:'#fff', padding:'40px 0'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">                            
                            <p data-aos="fade-right" style={{fontSize:'19px',textAlign:'center'}}>
                            {props.content}                            
                            </p>
                        </div>
                    </div>
                </div>
            </section>  
            
            {props.banner3 ? 
                <section className="company-bg" style={{background:`url(${props.banner3})`,backgroundSize:'cover'}}></section> 
                :
                <></>
            }

            <Count/>  

            <section>
                <div className="container tw-pt-10 md:tw-pt-15">
                    <div
                    className=" row tw-bg-[#157438] tw-text-white tw-p-[30px] md:tw-p-[60px] tw-my-[50px] tw-mx-auto tw-rounded-[30px] tw-flex tw-flex-wrap"
                    >
                    {/* Left Content */}
                    <div className="col-sm-9 col-12">
                        <h3 className="tw-text-[35px] tw-font-semibold tw-leading-tight tw-mb-4 max-md:tw-text-[24px]">
                            Lets Get Working
                        </h3>
                        <h5 className="tw-mb-2">At Fractile, you'll work on impactful projects, learn from seasoned leaders, and grow your technical craft. If you're committed to excellence, we're committed to you.</h5>
                    </div>

                    {/* Right Button */}
                    <div className="col-sm-3 col-12 tw-flex tw-items-end max-sm:tw-mt-6 md:tw-pt-0 tw-pt-5">
                        <button className="btn-2-white  tw-w-[80%] md-tw-w-[350px]"  onClick={() => setOpenModal(true)}>
                           Discuss Your Project
                        </button>
                    </div>
                    </div>
                </div>
            </section>

             <BookCall isOpen={openModal} onClose={() => setOpenModal(false)}/>    
        </>
    )
}

export default ServicesLayout;